import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { NativeMongoDbDataset } from 'app/model/dataset/native-mongo-db.dataset';
import { TabularTypeDatasetAdapter } from 'app/model/adapters/datasets/tabular-type.dataset.adapter';
import { HierarchicalNode } from 'app/model/dataset/hierarchicalnode';
import { parseJsonSchema } from './json.dataset.adapter';
import { ValueAdapter } from '../value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(NativeMongoDbDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            folder: '*',
            annotations: '*',
            linkedServiceName: '*',
            parameters: '*',
            type: '*',
            version: __IS_FABRIC_DPE__ ? '*' : undefined,
            typeProperties: {
                collection: '*',
                database: __IS_FABRIC_DPE__ ? '*' : undefined
            }
        }
    }
})
export class NativeMongoDbDatasetAdapter extends TabularTypeDatasetAdapter<NativeMongoDbDataset, Model.DatasetResource> {
    public parseHierarchicalSchema(obj: unknown): HierarchicalNode {
        try {
            return parseJsonSchema(obj, 'schema');
        } catch {
            return undefined;
        }
    }

    protected async _toResource(dataset: NativeMongoDbDataset): Promise<Model.DatasetResource> {
        const modelDataset = await this._toResourceInternal(dataset, Metamodel.modelFor(NativeMongoDbDataset).name, 'collection');
        if (__IS_FABRIC_DPE__ || this.context.adapterConfig.convertToFabric) {
            modelDataset.properties.typeProperties.database = ValueAdapter.toResource(
                dataset,
                NativeMongoDbDataset.DATABASE
            );

            modelDataset.properties.version = ValueAdapter.toResource(dataset, NativeMongoDbDataset.VERSION);
        }
        return modelDataset;
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: NativeMongoDbDataset): Promise<NativeMongoDbDataset> {
        dataset = await this._toModelInternal(modelDatasetResource, dataset, NativeMongoDbDataset.MODEL, 'collection');
        if (modelDatasetResource.properties?.typeProperties) {
            ValueAdapter.toModel(
                dataset,
                NativeMongoDbDataset.DATABASE,
                modelDatasetResource.properties.typeProperties.database
            );

            if (__IS_FABRIC_DPE__) {
                dataset.version = undefined;
                ValueAdapter.toModel(
                    dataset,
                    NativeMongoDbDataset.VERSION,
                    modelDatasetResource.properties?.version
                );
            }
        }
        return dataset;
    }
}
